import { useQuery } from 'react-query'
import { axios } from 'lib'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { OrderProduct } from 'modules/orders/types'

type Data = PaginatedParams & {
  orderId: string
  sequence: number
}

const fetcher = (data: Data): PaginatedResponse<OrderProduct> => {
  const { page = 1, limit = 10, orderId, sequence } = data

  return axios.get(`/orders/${orderId}/items/${sequence}/trackings`, {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadItemAttachments(query: Data) {
  return useQuery(['itemAttachments', query], () => fetcher(query), {
    enabled: !!query.orderId && !!query.sequence,
    onError: () =>
      toast.error('Não foi possível carregar os acompanhamentos!', {
        toastId: 'itemAttachments'
      })
  })
}
